import React, {FC, useEffect} from 'react'
import {Check, Tooltip} from '@mdsol/onex-design'
import {useSelector} from 'react-redux'
import {useAppDispatch} from 'redux/config'
import {RescheduleJobsAC} from 'redux/jobs/rescheduleJobs.duck'
import {select_rescheduleJobs_selected} from 'redux/jobs/selectors'
import {isJobPermissibleForRescheduling} from 'helpers/jobs'
import {CellPropsType} from './cellPropsType'
import {JobStatus} from 'graphql-api'

const SelectRowCell: FC<CellPropsType> = ({cell}) => {
  const dispatch = useAppDispatch()

  const getValue = cell.row.getValue
  const jobStatus = getValue('status')
  const isJobForRescheduling = isJobPermissibleForRescheduling(jobStatus as JobStatus)

  const {jobId} = cell.row.original
  const jobsSelectedForRescheduling = useSelector(select_rescheduleJobs_selected)
  const checked = !!jobsSelectedForRescheduling[jobId]

  const tooltipMessage = isJobForRescheduling
    ? checked
      ? 'Selected for rescheduling'
      : 'Reschedule this job'
    : ''

  const onChange = () => {
    if(checked) {
      dispatch(RescheduleJobsAC.jobDeselected(jobId))
    } else {
      dispatch(RescheduleJobsAC.jobSelected(jobId))
    }
  }

  // this hook takes care of individual checkbox toggle as well as Select All checkbox toggle from the header
  useEffect(() => {
    cell.row.toggleSelected(checked)
  }, [cell.row, checked])

  return (
    <Tooltip
      id='reschedule-job-tooltip'
      tooltipChildren={tooltipMessage}
      placement='bottom-start'
    >
      <Check
        dataTestId='reschedule-checkbox'
        disabled={!isJobForRescheduling}
        checked={checked}
        onChange={onChange}
      />
    </Tooltip>
  )
}

export default SelectRowCell
